export default "__VITE_ASSET__34PoSqVs__"